import styled, { keyframes } from 'styled-components';

interface IEmailVerificationProps {
  $isHidden?: boolean;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const WrapperInput = styled.div<IEmailVerificationProps>`
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'block')};
  width: 100%;
  max-width: 30rem;
  margin: 2rem 0;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: -2rem;
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
  margin-top: 1rem;
`;

export const ErrorMessageText = styled.p`
  font-size: 1rem;
`;

export const ErrorMessageButtonWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: -2rem;
`;

export const Spinner = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  border: 0.188rem solid ${({ theme }) => theme.colors.bgWhite};
  border-top: 0.188rem solid transparent;
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
`;
